export default __webpack_public_path__ + "static/media/challenge-token-subdued.a37f1de5.svg";